import { SetProjectSlidesRecordOnlyDocument } from "@/generated/graphql";
import { withToast } from "@/lib/utils/withToast";
import { useMutation } from "@apollo/client/react";

export function useSetProjectSlidesRecordOnly() {
  const [mutate, { loading }] = useMutation(SetProjectSlidesRecordOnlyDocument);

  const setProjectSlidesRecordOnly = async (projectId: string, recordOnly: boolean) => {
    return withToast(
      async () => {
        const res = await mutate({
          variables: { projectId, recordOnly },
        });
        return res.data?.setProjectSlidesRecordOnly ?? [];
      },
      {
        loading: recordOnly ? "Enabling record-only..." : "Disabling record-only...",
        success: recordOnly
          ? "Record-only enabled on all supported slides in this project"
          : "Record-only disabled on all supported slides in this project",
        error: "Failed to update slides. Please try again.",
      },
      "setProjectSlidesRecordOnly"
    );
  };

  return { setProjectSlidesRecordOnly, loading };
}
